import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import { loginInfo } from '@/api/user'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    role: Cookies.get('xt-role') || '',
    viewId: Cookies.get(window.location.pathname) || 'discover',
    audiolist: JSON.parse(sessionStorage.getItem('audioList')) || []
  },
  mutations: {
    LOGININFO: (state, info) => {
      state.isLogin = info
    },
    SET_ROLE: (state, role) => {
      state.role = role
      var inFifteenMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
      Cookies.set('xt-role', role, {
        expires: inFifteenMinutes
      });
    },
    SET_AUDIOLIST: (state, list) => {
      state.audiolist = list
      sessionStorage.setItem('audioList', JSON.stringify(list))
    }
  },
  actions: {
    loginInfo({ commit }) {
      return new Promise((resolve, reject) => {
        loginInfo().then((response)=>{
          const { data } = response
          commit('LOGININFO', data.data)
          resolve(data)
        }).catch(error => {
          if(error == 311){
            commit('LOGININFO', true)
          }
          reject(error)
        })
      })
    }
  },
  modules: {
  },
  getters: {
    isLogin: status => status.isLogin,
    role: status => status.role,
    audiolist: status => status.audiolist,
    viewId: status => status.viewId
  }
})
